import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,
	state: {
		cardammanAmount: []
	},

	actions: {
		fetchAll({ commit }, { itemId, fromDate, toDate, page, perPage }) {
			return axios.get('/itemTransaction', {
				params: { itemId, fromDate, toDate, page, perPage, sortByCreatedAt: true, nonDeleted: true }
			})
		},

		fetchCardammon({ commit }, { cardammomStatus, Withdetails }) {
			return axios.get('/itemTransaction/Inventory/cardammom', { params: { cardammomStatus, Withdetails } }).then((data) => {
				commit(types.STORE_CARDAMMON_INSORTING, data)
				return data
			})
		}
	},

	mutations: {
		[types.STORE_CARDAMMON_INSORTING](state, cardammanAmount) {
			state.cardammanAmount = cardammanAmount
		}
	}
}